import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CsrOrderNotes defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CsrOrderNotesService } from 'services/csrOrderNotes';
 *
 * // create service instance and send/cancel request
 * const csrOrderNotesService = new CsrOrderNotesService();
 * const result = await csrOrderNotesService.fetchData( '<user-id>' ); // fetch data
 * csrOrderNotesService.cancel(); // cancel an active request
 */
export class CsrOrderNotesService extends HttpService {

    // make request and fetch data
    async submitAddNote( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // Fetch Order NOtes
    async fetchOrderNotes( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // const actions = get( response, 'body.component.structure.actions', [] );
            // const formActions = get( response, 'body.component.structure.formActions', [] );
            // const title = get( response, 'body.component.structure.title', '' );
            // const displayDateText = get( response, 'body.component.structure.displayDateText', '' );
            // const fields = get( response, 'body.component.structure.fields', '' );
            const items = get( response, 'body.component.data.state.items', '' );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: { items },
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
